import React, { useEffect, useState } from "react";

// 공통 컴포넌트
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import { DaySelectBoxV2 } from "../common/DaySelectBoxV2";
import { PageBtnV2 } from "../common/PageBtnV2";
import { ReviewCardV2 } from "./ReviewCardV2";

// 훅 및 유틸 함수
import { useReviewList } from "../../../static/js/hock/reviewHock";
import {
  getNextDay,
  getParameter,
  getToday,
  getValue,
} from "../../../static/js/Common2";
import { subNavEvent } from "../../../static/js/service/commonService";
import { closePopup } from "../../../utils/CommonUtils";

// 스타일 및 이미지
import "../../../static/css/manage.css";
import arrow1 from "../../../static/image/v2/selectArrow1.png";
import arrow2 from "../../../static/image/v2/selectArrow2.png";
import popupCross from "../../../static/image/v2/popup/closeV3.png";
import { ReactComponent as Bar } from "assets/images/bar.svg";

export default function ReviewListV2() {
  // 상점 관련 상태값
  const [shopList, setShopList] = useState([]);
  const [shopId, setShopId] = useState();

  // 리뷰 관련 상태값
  const [reviewList, setReviewList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [shopReplyCount, setShopReplyCount] = useState(0);
  const [evaluationCountList, setEvaluationCountList] = useState([]);

  // URL 파라미터 값 (기본값 설정 포함)
  const sortType = Number(getParameter("sortType")) || 1;
  const filter = Number(getParameter("filter")) || 0;
  const page = getParameter("page") === null ? 1 : Number(getParameter("page"));
  const startDate =
    getParameter("startDate") === null ? getToday() : getParameter("startDate");
  const endDate =
    getParameter("endDate") === null ? getNextDay() : getParameter("endDate");
  const keyword =
    getParameter("keyword") === null ? "" : getParameter("keyword");
  const searchType =
    getParameter("searchType") === null ? 1 : getParameter("searchType");
  const dayType =
    getParameter("dayType") === null ? 1 : Number(getParameter("dayType"));

  // 리뷰 조회에 필요한 요청 데이터
  let data;
  if (shopId) {
    data = {
      page: page,
      count: 5,
      shopId: shopId,
      startDate,
      endDate,
      reviewSortType: sortType,
    };
    if (filter !== 0) data.evaluationType = filter;
    if (keyword !== "") {
      data.keyword = keyword;
      data.searchType = searchType;
    }
  }

  // 리뷰 리스트 조회 훅 호출
  useReviewList(
    {
      setReviewList,
      setTotalCount,
      setShopReplyCount,
      setEvaluationCountList,
    },
    data
  );

  // 서브 네비게이션 활성화
  useEffect(() => {
    subNavEvent("manageNav", "manage1");
  }, []);

  // 리뷰 리스트 UI 생성
  const reviewListBox = reviewList.map((value, index) => (
    <ReviewCardV2 review={value} key={index} />
  ));

  // 검색 버튼 이벤트
  function searchBtn(getPage, getSortType, getFilter) {
    const getName = document.getElementById("nameInput").value;
    const getStartDate = document.getElementById("startDate").value;
    const getEndDate = document.getElementById("endDate").value;
    const getDayType = document
      .getElementById("daySelectText")
      .getAttribute("data-type");
    const keywordType = getValue("keywordType");
    const keyword = getValue("nameInput");

    window.location.href = `/v2/review?page=${
      getPage || 1
    }&shopSelect=${shopId}&name=${getName}&startDate=${getStartDate}&endDate=${getEndDate}&page=${page}&dayType=${getDayType}&searchType=${keywordType}&keyword=${keyword}&sortType=${
      getSortType || 1
    }&filter=${getFilter || 0}`;
  }

  return (
    <>
      {/* 리뷰 이미지 팝업 */}
      <div id="reviewPopup" className="popup d-flex a-center j-center hide">
        <div className="popupContent d-flex a-start j-center">
          <div className="imageBox scrollbar">
            <img id="reviewPopupImage" src="" alt="리뷰 이미지" />
          </div>
          <button>
            <img
              className="ml-15"
              src={popupCross}
              alt="닫기"
              onClick={() => closePopup("reviewPopup")}
            />
          </button>
        </div>
      </div>

      {/* 메인 콘텐츠 */}
      <main id="ReviewListV2" className="mainV2">
        <TopBoxV2 shopList={shopList} />
        <div className="container">
          <section className="containerInner">
            {/* 페이지 타이틀 */}
            <PageNameV2 title1="운영 관리" title2="리뷰 관리" />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="리뷰 관리" countText="" count="" unit="" />
            </div>

            {/* 상점 선택 */}
            <div className="topMenu">
              <div id="shopSelectBox">
                <ShopSelectBoxV2
                  url="/v2/review"
                  setShopId={setShopId}
                  setShopList={setShopList}
                />
              </div>
            </div>

            {/* 검색 영역 */}
            <div className="topMenu selectBox">
              <DaySelectBoxV2
                startDate={startDate}
                endDate={endDate}
                dayType={dayType}
              />
              <Bar className="ml-5 mr-10" />
              <select
                id="keywordType"
                className="select2 width160"
                defaultValue={searchType}
              >
                <option value={1}>닉네임</option>
                <option value={2}>휴대폰번호</option>
              </select>
              <input
                type="text"
                id="nameInput"
                name="nameInput"
                className="inputBoxHeight40 width200"
                placeholder="검색어"
                key={keyword}
                defaultValue={keyword}
              />
              <button
                type="button"
                id="searchBtn"
                className="commonBtn blueBtn width90 marginLeft5"
                onClick={() => searchBtn()}
              >
                검색
              </button>
            </div>

            {/* 리뷰 통계 */}
            <div className="d-flex a-center j-between">
              <div className="d-flex a-center j-left mt-20 mb-20">
                <p className="mr-20">
                  전체
                  <span className="fc-blue fw-7">
                    {totalCount.toLocaleString()}
                  </span>
                  개 / 미답변
                  <span className="fc-blue fw-7">
                    {totalCount - shopReplyCount > 0
                      ? (totalCount - shopReplyCount).toLocaleString()
                      : 0}
                  </span>
                  개
                </p>
                <p>
                  좋아요
                  <span className="fc-red fw-7">
                    {evaluationCountList.find((item) => item.type === 1)
                      ? evaluationCountList
                        .find((item) => item.type === 1)
                        .count.toLocaleString()
                      : 0}
                  </span>
                  개 / 아쉬워요
                  <span className="fw-7">
                    {evaluationCountList.find((item) => item.type === 2)
                      ? evaluationCountList
                        .find((item) => item.type === 2)
                        .count.toLocaleString()
                      : 0}
                  </span>
                  개
                </p>
              </div>

              {/* 필터 및 정렬 */}
              <div className="d-flex a-center j-right reviewFilter">
                <div className="btnBox d-flex a-center j-center">
                  <button
                    className={`${filter === 0 ? "active" : ""}`}
                    onClick={() => searchBtn(1, sortType, 0)}
                  >
                    전체
                  </button>
                  <button
                    className={`${filter === 1 ? "active" : ""}`}
                    onClick={() => searchBtn(1, sortType, 1)}
                  >
                    좋아요
                  </button>
                  <button
                    className={`${filter === 2 ? "active" : ""}`}
                    onClick={() => searchBtn(1, sortType, 2)}
                  >
                    아쉬워요
                  </button>
                </div>
                <div
                  className="fw-5 fc-gray2 ml-15"
                  onClick={() =>
                    searchBtn(1, sortType === 1 ? 4 : 1, filter)
                  }
                >
                  <img
                    className="arrow mr-10"
                    src={sortType === 1 ? arrow1 : arrow2}
                    alt="화살표"
                  />
                  {sortType === 1 ? "최근 등록 순" : "과거 등록 순"}
                </div>
              </div>
            </div>

            {/* 리뷰 리스트 */}
            <div className="commonBox first">
              <div className="reviewBox"></div>
              {reviewListBox}
            </div>

            {/* 페이지네이션 */}
            <PageBtnV2
              listCount={totalCount}
              count={5}
              page={page}
              url={"/v2/review"}
            />
          </section>
        </div>
      </main>
    </>
  );
}
